import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="relative py-16 px-6 overflow-hidden bg-rose-light/20" data-id="element-114">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-115">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-rose-light/40 rounded-full blur-3xl" data-id="element-116"></div>
        <div className="absolute -bottom-[20%] -right-[10%] w-[50%] h-[50%] bg-gold-light/30 rounded-full blur-3xl" data-id="element-117"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-119">
          <h2 className="text-3xl md:text-5xl font-bold text-dark mb-4 leading-tight" data-id="element-120">
            TODO LO QUE NECESITÁS PARA TEJER SIN LÍMITES{' '}
            <span className="italic text-rose-deep font-normal block mt-1" data-id="element-121">
              ESTÁ EN UN SOLO LUGAR
            </span>
          </h2>

          <p className="text-lg md:text-xl text-dark/80 mb-8 max-w-2xl mx-auto font-medium" data-id="element-122">
            Más de 4.000 patrones premium organizados para que nunca vuelvas a
            quedarte sin ideas.
          </p>

          <div className="flex flex-wrap justify-center gap-y-3 gap-x-6 mb-10 text-sm md:text-base text-dark/80 font-bold bg-white/60 backdrop-blur-md py-6 px-8 rounded-3xl border border-white max-w-3xl mx-auto shadow-sm" data-id="element-123">
            {['Amigurumis', 'Deco hogar', 'Bebés y niños', 'Tops y blusas', 'Sweaters', 'Bonos exclusivos', 'Acceso inmediato'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-124">
                <div className="bg-rose-deep/10 p-1 rounded-full" data-id="element-125">
                  <Check className="w-4 h-4 text-rose-deep" data-id="element-126" />
                </div>
                <span data-id="element-127">{item}</span>
              </div>)}
          </div>

          <div className="flex justify-center" data-id="element-128">
            <CTAButton size="large" data-id="element-129" />
          </div>
        </motion.div>
      </div>
    </section>;
}